import React, { useEffect, useState } from 'react'
import './index.css'

import { NavLinks } from './NavLinks'

const Header = () => {
  return <NavLinks />
}

export default Header
